import { ComponentType, lazy } from 'react'

const FLAG = 'chunk-reload'

// After a deploy the previous build's hashed chunks are gone from the server, so a tab opened
// before the deploy fails to import() a not-yet-loaded route chunk. A full reload pulls the fresh
// index.html and new chunks, which recovers the user. The flag guards against an infinite reload
// loop when the failure is not a stale deploy: we reload at most once, then surface the error.
export const reloadForChunkError = () => {
	if (sessionStorage.getItem(FLAG)) {
		return false
	}

	sessionStorage.setItem(FLAG, '1')
	window.location.reload()

	return true
}

export const clearChunkReloadFlag = () => sessionStorage.removeItem(FLAG)

// Generic over the props so components with and without props are both accepted, unlike ComponentType<unknown>.
export const lazyWithRetry = <P extends object>(factory: () => Promise<{ default: ComponentType<P> }>) =>
	lazy(() =>
		factory()
			.then((module) => {
				clearChunkReloadFlag() // a chunk loaded fine, so reset the guard for the next deploy
				return module
			})
			.catch((error) => {
				if (reloadForChunkError()) return new Promise<{ default: ComponentType<P> }>(() => {}) // hang Suspense until reload navigates away
				throw error // already reloaded once and still failing, let the route errorElement handle it
			}),
	)
